import React, { useEffect, useState } from "react";

export function AdminNotesUser({ userData, darkMode, userNotes }) {
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    setActiveTab(0);
  }, []);

  return (
    <div>
      <div className="card card-flush mb-6 mb-xl-9" style={{ height: '600px' }}>
        <div className="card-header mt-6">
          <div className="card-title flex-column">
            <h2 className="mb-1">Notas do Questionario</h2>
            <div className="fs-6 fw-semibold text-muted">Total 12 perguntas</div>
          </div>
        </div>

        {userData.relatorioEnviado == 1 ? (
          <div className="card-body p-9 pt-4">
          <ul className="nav nav-pills d-flex flex-nowrap hover-scroll-x py-2">
            {userNotes.map((_, index) => (
              <li className="nav-item me-1" key={index}>
                <a
                  className={`nav-link btn d-flex flex-column flex-center rounded-pill min-w-40px me-2 py-4 btn-active-primary ${
                    activeTab === index ? 'active' : ''
                  }`}
                  data-bs-toggle="tab"
                  href={`#kt_schedule_day_${index}`}
                  onClick={() => setActiveTab(index)}
                >
                  <span className="opacity-50 fs-7 fw-semibold">Pergunta</span>
                  <span className="fs-6 fw-bolder">{index + 1}</span>
                </a>
              </li>
            ))}
          </ul>

          <div className="tab-content">
            {userNotes.map((questao, index) => {
              const date = new Date(questao.data);
              const formattedDate = date.toLocaleDateString();
              const formattedTime = date.toLocaleTimeString([], {
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
              });

              return (
                <div
                  id={`kt_schedule_day_${index}`}
                  className={`tab-pane fade ${activeTab === index ? 'active show' : ''}`}
                  key={index}
                >
                  <div className="fs-7 mb-1">
                    {formattedDate} às {formattedTime}
                  </div>
                  <div className="d-flex flex-stack position-relative mt-6">
                    <div className="position-absolute h-100 w-4px bg-secondary rounded top-0 start-0"></div>
                    <div className="fw-semibold ms-5">
                      <p className="fs-5 text-gray-900 text-hover-primary mb-2">
                        Questão A: <span className="fw-bold">{questao.notaA}</span> Pontos
                      </p>
                    </div>
                  </div>
                  <div className="d-flex flex-stack position-relative mt-6">
                    <div className="position-absolute h-100 w-4px bg-secondary rounded top-0 start-0"></div>
                    <div className="fw-semibold ms-5">
                      <p className="fs-5 text-gray-900 text-hover-primary mb-2">
                        Questão B: <span className="fw-bold">{questao.notaB}</span> Pontos
                      </p>
                    </div>
                  </div>
                  <div className="d-flex flex-stack position-relative mt-6">
                    <div className="position-absolute h-100 w-4px bg-secondary rounded top-0 start-0"></div>
                    <div className="fw-semibold ms-5">
                      <p className="fs-5 text-gray-900 text-hover-primary mb-2">
                        Questão C: <span className="fw-bold">{questao.notaC}</span> Pontos
                      </p>
                    </div>
                  </div>
                  <div className="d-flex flex-stack position-relative mt-6">
                    <div className="position-absolute h-100 w-4px bg-secondary rounded top-0 start-0"></div>
                    <div className="fw-semibold ms-5">
                      <p className="fs-5 text-gray-900 text-hover-primary mb-2">
                        Questão D: <span className="fw-bold">{questao.notaD}</span> Pontos
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        ) : (
          <div className="card-body p-9 pt-4">
            <p>Usuário não terminou o questionário. Não possui informações suficientes</p>
          </div>
        )}
      </div>
    </div>
  );
}
